import { RootState } from "../store";
import { createSelector, createSlice } from "@reduxjs/toolkit";

interface IAffiliatesState {
  affiliatesJoinPopupOpen: boolean;
}

const initialState: IAffiliatesState = {
  affiliatesJoinPopupOpen: false,
};

export const affiliatesSlice = createSlice({
  name: "affiliates",
  initialState,
  reducers: {
    setAffiliatesJoinPopupOpen(state) {
      state.affiliatesJoinPopupOpen = true;
    },
    setAffiliatesJoinPopupClose(state) {
      state.affiliatesJoinPopupOpen = false;
    },
  },
});

const affiliatesState = (state: RootState) => state.affiliates;

export const affiliatesJoinPopupOpenSelector = createSelector(
  affiliatesState,
  (s) => s.affiliatesJoinPopupOpen
);

export const { setAffiliatesJoinPopupOpen, setAffiliatesJoinPopupClose } =
  affiliatesSlice.actions;

export default affiliatesSlice.reducer;
